import { useState } from 'react';

export default function Tags({ data, setData }) {
    const [tag, setTag] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [dragIndex, setDragIndex] = useState(null);

    const onDargStart = (index) => {
        setDragIndex(index);
    };

    const onDragOver = (event) => {
        event.preventDefault();
    };

    const onDrop = (dropIndex) => {
        if (dragIndex === null && dragIndex === dropIndex) return;
        const updatedTags = [...data.tags];
        const draggedItem = updatedTags[dragIndex];
        updatedTags.splice(dragIndex, 1);
        updatedTags.splice(dropIndex, 0, draggedItem);
        setData((prev) => ({
            ...prev,
            tags: updatedTags
        }));

        setDragIndex(null);
    };

    function addTag() {
        if (tag === '') {
            setErrorMsg('Tag cannot be empty');
        } else {
            setData(function (prevState) {
                return { ...prevState, tags: [...prevState?.tags, tag] };
            });
            setTag('');
            setErrorMsg('');
        }
    }
    function removeTag(text) {
        const tempArray = data.tags;
        let index = tempArray.indexOf(text);
        tempArray.splice(index, 1);
        setData(function (prevState) {
            return { ...prevState, tags: [...tempArray] };
        });
    }
    return (
        <div>
            <h2 className='orgPackUpH2'>Tags</h2>
            <div className='orgPackUpSecDiv'>
                <div>
                    <p className='tagsNoteP'>
                        Note: Tags are used for search support, You need to add one of the tag as organizer name
                        complsorily. Add all the other relevant words which people might use to search your package. You
                        can add up to 30 tags with max length 30 letters each.
                    </p>
                    <br></br>
                    <p className='tagsNoteP'>
                        Note: If any of the below topics are related to your trip, please add them to tags.
                        <b>
                            {' '}
                            Topics - “Adventure“, "One day trip”, “Two days trip”, “Trek”, “Island”, “Mountains”,
                            “Beach”, “Road trip”, "Backpacking”, “Snow”, “Hike”.
                        </b>
                    </p>
                </div>
                <div className='itineraryInDiv custom'>
                    <label className='itineraryLabel'>Tags</label>
                    <div className='itineraryInputDiv'>
                        <input
                            type='text'
                            onChange={(e) => {
                                setTag(e.target.value);
                                setErrorMsg('');
                            }}
                            placeholder='Enter and press Add Tag to add'
                            value={tag}
                            className='nestedTagInput'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    addTag();
                                }
                            }}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            style={{
                                border: errorMsg
                                    ? isFocused
                                        ? '2px solid #ff0000'
                                        : '2px solid #f96f72ff'
                                    : isFocused
                                      ? '2px solid #000'
                                      : '1px solid #000',
                                outline: 'none'
                            }}
                        ></input>
                        <button type='button' onClick={addTag} className={`nestedTagOkBtn blueBtn`}>
                            Add Tag
                        </button>
                    </div>
                </div>
                {errorMsg && <span className='tag-error-text'>{errorMsg}</span>}
                <p className='dragNote' style={{ marginTop: '20px' }}>
                    Note: Use drag and drop to reorder the Wallpaper images
                </p>
                {data?.tags?.length > 0 && (
                    <div className='tagContainer'>
                        <div className='tagOutDiv'>
                            {data.tags.map((text, index) => {
                                return (
                                    <div
                                        key={index}
                                        draggable
                                        onDragStart={() => onDargStart(index)}
                                        onDragOver={onDragOver}
                                        onDrop={() => onDrop(index)}
                                        className='tagDiv'
                                    >
                                        <p className='tagP'>{text}</p>
                                        <button
                                            className='tagButton'
                                            onClick={(e) => {
                                                removeTag(text);
                                            }}
                                        >
                                            X
                                        </button>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
